import React, { useId } from 'react';
import { motion } from 'framer-motion';

const Logo = ({ darkMode, className = '' }) => {
  const rawId = useId();
  const uid = rawId.replace(/:/g, '');
  const gradMain = `logo-solentra-main-${uid}`;
  const gradGold = `logo-solentra-gold-${uid}`;

  // Animation variants
  const svgVariants = {
    hover: {
      scale: 1.04,
      transition: { duration: 0.3, ease: "easeOut" }
    }
  };
  const pathVariants = {
    hover: {
      scale: 1.06,
      transition: { duration: 0.4, ease: "easeOut" }
    }
  };
  const textVariants = {
    hover: {
      y: [-1, 1, -1],
      transition: { duration: 2, ease: "easeInOut", repeat: Infinity, repeatType: "mirror" }
    }
  };

  return (
    <motion.div
      className={`flex items-center space-x-2 ${className}`}
      whileHover="hover"
      initial="initial"
      style={{ minHeight: 40 }}
    >
      {/* S monogram + growth accent (Solentra) */}
      <motion.svg
        className="h-8 w-8 flex-shrink-0"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        variants={svgVariants}
        aria-hidden
      >
        <defs>
          <linearGradient id={gradMain} x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
            <stop stopColor={darkMode ? '#22d3ee' : '#0284c7'} />
            <stop offset="1" stopColor={darkMode ? '#38bdf8' : '#22d3ee'} />
          </linearGradient>
          <linearGradient id={gradGold} x1="8" y1="20" x2="26" y2="10" gradientUnits="userSpaceOnUse">
            <stop stopColor="#fbbf24" />
            <stop offset="1" stopColor="#f59e0b" />
          </linearGradient>
        </defs>
        {/* Stylized S: capital letter for Solentra */}
        <motion.path
          d="M 19.75 6.75 C 10.5 6.75 5.5 10.35 5.5 15.35 C 5.5 18.85 8.65 21.05 14.85 21.45 C 21.05 21.85 24.75 23.95 24.75 27.15 C 24.75 30.05 20.35 31.85 12.85 30.85"
          stroke={`url(#${gradMain})`}
          strokeWidth="3.15"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          variants={pathVariants}
        />
        {/* Ascending accent — trajectory / compounding */}
        <motion.path
          d="M 20.5 6.5 L 25.5 4.5 M 23.5 5.5 L 25.5 4.5 L 24.5 6.8"
          stroke={`url(#${gradGold})`}
          strokeWidth="1.85"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          variants={pathVariants}
        />
        <motion.circle cx="19.75" cy="6.75" r="1.65" fill="#fbbf24" variants={pathVariants} />
      </motion.svg>
      {/* Text */}
      <motion.div
        className={`flex flex-col leading-tight ${darkMode ? 'text-white' : 'text-slate-900'}`}
        variants={textVariants}
        style={{ lineHeight: 1 }}
      >
        <div className="flex items-baseline">
          <span className={`font-display text-lg font-semibold tracking-tight ${darkMode ? 'text-white' : 'text-slate-900'}`}
            style={{letterSpacing: '0.01em'}}>
            Solentra
          </span>
          <span className={`font-display text-lg font-light tracking-tight ml-1 ${darkMode ? 'text-cyan-200' : 'text-cyan-700'}`}
            style={{letterSpacing: '0.01em'}}>
            Investments
          </span>
        </div>
        <span className={`text-[0.65rem] font-medium tracking-widest uppercase mt-0.5 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}
          style={{letterSpacing: '0.13em'}}>
          Portfolio advisory
        </span>
      </motion.div>
    </motion.div>
  );
};

export default Logo;